export enum ProductType {
  All = 'all',
  App = 'app',
  Chatbot = 'chatbot',
  Other = 'other',
}

export type ProductTypeKey = keyof typeof ProductType

/**
 * Maps a UI product segment to the booking-conversion `source` param (PostHog
 * events): App → mobile, Chatbot → whatsapp. All/Other → undefined so no
 * `source` is sent and the aggregate funnel is returned.
 */
export const productTypeToAnalyticsSource = (
  product?: ProductType
): 'mobile' | 'whatsapp' | undefined => {
  switch (product) {
    case ProductType.App:
      return 'mobile'
    case ProductType.Chatbot:
      return 'whatsapp'
    default:
      return undefined
  }
}

export const productTypeMeta: Record<
  ProductType,
  { name: string; color: string }
> = {
  [ProductType.All]: {
    name: 'All',
    color: '#999999',
  },
  [ProductType.App]: {
    name: 'App',
    color: '#4F46E5',
  },
  [ProductType.Chatbot]: {
    name: 'Chatbot',
    color: '#10B981',
  },
  [ProductType.Other]: {
    name: 'Other',
    color: '#6B7280',
  },
}
